<template>
  <ul class="tabs">
    <li
      class="tab"
      v-for="(item, index) in list"
      :key="index"
      :class="{ 'tab--active': activeIndex === index }"
      @click="changeTab(item.path)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'JinNangTabs',
  props: {
    data: Array
  },
  data() {
    return {
      list: [
        { name: '资金持仓', path: '/repo', index: 0 },
        { name: '买入', path: '/buy', index: 1 },
        { name: '卖出', path: '/sale', index: 2 },
        { name: '撤单', path: '/cancle', index: 3 },
        { name: '查询', path: '/query', index: 4 }
      ]
    }
  },
  computed: {
    activeIndex() {
      const path = this.$route.path
      return this.list.findIndex(item => path.indexOf(item.path) > 0)
    }
  },
  methods: {
    changeTab(path) {
      const routePath = this.$route.path
      var goIndex = -1
      this.list.forEach((element, index) => {
        if (routePath.indexOf(element.path) > 0) {
          goIndex = index
        }
      })
      this.$router.push(
        goIndex === -1
          ? routePath + '/' + path
          : routePath.substring(0, routePath.lastIndexOf('/')) + path
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 314px;
  font-size: 16px;
  color: #262626;
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 5px;

  .tab {
    height: 54px;
    line-height: 54px;
    cursor: pointer;
    text-align: center;
    border-left: 4px solid white;
  }

  .tab--active {
    color: #046bcc;
    background-color: rgba($color: #046bcc, $alpha: 0.1);
    border-left: 4px solid #046bcc;
    border-radius: 5px 0px 0px 5px;
  }
}
</style>
